import {StringValidacao} from './string';
import {Construtor} from './construtor';
import { CriterioAvaliacaoRotinaCliente } from './criterio-avaliacao-rotina-cliente';
import {CriticidadeRotina} from './criticidade-rotina';

export class RotinaCliente implements Construtor<RotinaCliente> {

  public idRotinaCliente: number;
  public descricaoRotina: string;
  public idRotina: number;
  public idCliente: number;
  public metodoAvaliacaoRotina: string;
  public criticidadeRotina: CriticidadeRotina;
  public criteriosAvaliacaoRotina: CriterioAvaliacaoRotinaCliente[];
  public selecionado: boolean;
  public alterado: boolean;

  constructor(object?: any) {
    this.criticidadeRotina = new CriticidadeRotina();
    this.criteriosAvaliacaoRotina = new Array<CriterioAvaliacaoRotinaCliente>();

    if (object !== undefined) {

      if (object instanceof RotinaCliente) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      return this.modeloCompleto() ? this : null;
    }

    return this;
  }

  get obterIdRotinaCliente(): number {
    return this.idRotinaCliente;
  }

  set IdRotinaCliente(idRotinaCliente: any) {
    this.idRotinaCliente = idRotinaCliente;
  }

  get obterDescricaoRotina(): string {
    return this.descricaoRotina.slice(0);
  }

  set DescricaoRotina(descricaoRotina: any) {
    this.descricaoRotina = StringValidacao.copiarStringValida(descricaoRotina);
  }

  get obterIdRotina(): number {
    return this.idRotina;
  }

  set IdRotina(idRotina: any) {
    this.idRotina = idRotina;
  }

  get obterMetodoAvaliacaoRotina(): string {
    return this.metodoAvaliacaoRotina.slice(0);
  }

  set MetodoAvaliacaoRotina(metodoAvaliacaoRotina: any) {
    this.metodoAvaliacaoRotina = StringValidacao.copiarStringValida(metodoAvaliacaoRotina);
  }

  get obterIdCliente(): number {
    return this.idCliente;
  }

  set IdCliente(idCliente: any) {
    this.idCliente = idCliente;
  }

  get obterCriticidadeRotina(): CriticidadeRotina {
    return this.criticidadeRotina;
  }

  set CriticidadeRotina(criticidadeRotina: any) {
    this.criticidadeRotina = criticidadeRotina;
  }

  get obterCriteriosAvaliacaoRotina(): CriterioAvaliacaoRotinaCliente[] {
    return this.criteriosAvaliacaoRotina;
  }

  set insertCriterioAvaliacaoRotina(criterioAvaliacaoRotina: CriterioAvaliacaoRotinaCliente) {
    this.criteriosAvaliacaoRotina.push(criterioAvaliacaoRotina);
  }

  set CriteriosAvaliacaoRotina(criteriosAvaliacaoRotina: any) {

    this.criteriosAvaliacaoRotina = new Array<CriterioAvaliacaoRotinaCliente>();

    if (criteriosAvaliacaoRotina !== undefined) {
      for (const criterioAvaliacaoRotina of criteriosAvaliacaoRotina) {
        this.insertCriterioAvaliacaoRotina = new CriterioAvaliacaoRotinaCliente(criterioAvaliacaoRotina);
      }
    }
  }

  copyObject(rotina: RotinaCliente): void {

    this.idRotinaCliente = rotina.obterIdRotinaCliente;
    this.descricaoRotina = rotina.obterDescricaoRotina;
    this.metodoAvaliacaoRotina = rotina.obterMetodoAvaliacaoRotina;
    this.idRotina = rotina.obterIdRotina;
    this.idCliente = rotina.obterIdCliente;
    this.criticidadeRotina = rotina.obterCriticidadeRotina;
    this.criteriosAvaliacaoRotina = rotina.obterCriteriosAvaliacaoRotina;
  }

  parseFromJson(rotina: any): void {

    this.IdRotinaCliente = rotina.idRotinaCliente;
    this.DescricaoRotina = rotina.descricaoRotina;
    this.MetodoAvaliacaoRotina = rotina.metodoAvaliacaoRotina;
    this.IdRotina = rotina.idRotina;
    this.IdCliente = rotina.idCliente;
    this.CriticidadeRotina = rotina.criticidadeRotina;
    this.criteriosAvaliacaoRotina = rotina.criteriosAvaliacaoRotina;
  }

  modeloCompleto(): boolean {
    return this.descricaoRotina !== undefined;
  }

  getNewInstance(object?: any): RotinaCliente {
    return new RotinaCliente(object);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/rotina-cliente.ts